import { EmailView } from "./_components";

export default function EmailPage() {
  return <EmailView />;
}
